import React from 'react';
import useCircuitBreaker from '../../hooks/useCircuitBreaker';

function NavBar() {
    // No mobile a sidebar fica colapsada, então o badge do breaker fica aqui (sempre visível) pra
    // o estado "automações pausadas" não passar despercebido sem abrir o menu.
    const { active } = useCircuitBreaker(30000);

    return (
        <React.Fragment>
            <nav className="navbar navbar-dark navbar-theme-primary px-4 col-12 d-lg-none">
                <a className="navbar-brand me-lg-5" href="/dashboard">
                    <img className="navbar-brand-light" src="/img/brand/light.svg" alt="Beholder logo" />
                </a>
                <div className="d-flex align-items-center">
                    {active && (
                        <a href="/settings" className="badge bg-danger text-white fw-bold me-3 d-flex align-items-center gap-1 text-decoration-none"
                            title="Circuit breaker ativo — automações pausadas. Toque para resetar nas Configurações.">
                            <svg className="icon icon-xxs" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                            </svg>
                            Breaker
                        </a>
                    )}
                    <button className="navbar-toggler d-lg-none collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                </div>
            </nav>
        </React.Fragment>
    );
}

export default NavBar;